import * as util from 'util'

// Fancy console log. Shows nested items in objects
function debug(object: Record<string, unknown> | unknown) {
  console.log(util.inspect(object, false, null, true))
}

export default debug
